import "./Bai17-24.css";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { khoiData} from "./khoiData";
import { jwtDecode } from "jwt-decode";

const Danhba34tinh = () => {
  const [activeItems, setActiveItems] = useState({});
  const [visitedItems, setVisitedItems] = useState({});
  const navigate = useNavigate();
  const itemRefs = useRef({});

  // Xử lý click vào tiêu đề
  const handleTitleClick = (index, e) => {
    e.preventDefault();

    // Toggle class xanh và trạng thái active
    setActiveItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
    // Đánh dấu là đã visited
    setVisitedItems(prev => ({
      ...prev,
      [index]: true
    }));

    // Scroll to top của phần tử
    if (itemRefs.current[index]) {
      const topPosition = itemRefs.current[index].offsetTop;
      window.scrollTo({
        top: topPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const readAccessToken = localStorage.getItem("accessToken");
        if (readAccessToken) {
          const checkExpired = jwtDecode(readAccessToken);
          if (checkExpired.exp < new Date() / 1000){
            localStorage.removeItem("accessToken");
            localStorage.clear();
            return navigate("/");
          }
        }
    Fancybox.bind("[data-fancybox]", {
      // Your custom options
    });

    // Cleanup khi component unmount
    return () => {
      Fancybox.destroy();
    };
  }, []);

  return (
    <>
      <div className="noidung">
        <h1 className="tieude">
          Danh bạ điện thoại
          <br />
          Hội Nông dân 34 tỉnh, thành phố
        </h1>
        {khoiData.map((khoi, index) => (
      <div key={index} className="_1motkhoi" ref={el => itemRefs.current[index] = el}>
        <h2 
          className={`tieudekhoi ${visitedItems[index] ? "visited" : ""}`} 
          onClick={(e) => handleTitleClick(index, e)}>
          {(index + 1).toString().padStart(2, '0')}. {khoi.nameProvince} {/* Thêm số thứ tự */}
          <img src="/images/arrow_down.png" alt="arrow" />
        </h2>

        <div 
          className="noidungkhoi" 
          style={{
            display: activeItems[index] ? 'block' : 'none',
            transition: 'all 0.5s ease-in-out'
          }}>
            <div className="vaicaianh">
              <a href={`/images/${khoi.photoName}1.jpg`} 
                data-fancybox={`${khoi.photoName}`} 
                data-caption="Ảnh thứ nhất">
                <img
                  className="anhnho"
                  src={`/images/${khoi.photoName}1.jpg`}
                  alt="Ảnh thứ nhất"
                />
              </a>
              <a href={`/images/${khoi.photoName}2.jpg`} 
                data-fancybox={`${khoi.photoName}`} 
                data-caption="Ảnh thứ hai">
                <img 
                  className="anhnho" 
                  src={`/images/${khoi.photoName}2.jpg`} 
                  alt="Ảnh thứ hai" />
              </a>
              <a href={`/images/${khoi.photoName}3.jpg`} 
                data-fancybox={`${khoi.photoName}`} 
                data-caption="Ảnh thứ ba">
                <img 
                  className="anhnho" 
                  src={`/images/${khoi.photoName}3.jpg`} 
                  alt="Ảnh thứ ba" />
              </a>
            </div>
            
            <div className="textLeftIndent">
              {khoi.address &&  <p><b>Trụ sở:</b> {khoi.address}</p>}
              {khoi.phone &&  <p><b>Điện thoại:</b> {khoi.phone} </p>}  
              {khoi.website && <p><b>Website:</b> {khoi.website} </p>}
              {khoi.email && <p><b>Email:</b> {khoi.email} </p>}
              {khoi.zipCode && <p><b>Mã vùng:</b> {khoi.zipCode} </p>}
              <p>&nbsp;</p>
            </div>
            <div className="tableOutside">
              <table className="tableBorder">
                  {khoi.contentComponent}
              </table>
            </div>
            
      </div>
    </div>
    ))}

      </div>
    </>
  );
};

export default Danhba34tinh;
